import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dd4b1ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mfa-page overflow-x-hide overflow-y-hide" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "row no-margin" }
const _hoisted_4 = { class: "col-md-12 flex-container" }
const _hoisted_5 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_6 = { class: "modal-content" }

import { nextTick, onMounted, ref } from "vue";
import $ from "jquery";
import HeaderLogo from "@/components/common/headerLogo.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern.vue";
import store from "@/store";
import router from "@/router";
import { UserRoute, homeRoute } from "@/services/apiRoutes/routes";
import { startRegistration } from "@simplewebauthn/browser";
import Utils from "@/utils/utilities";
import userService from "@/services/user/userService";
import mfaSelectionContent from "@/components/user/mfaSelectionContent.vue";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'mfaSelectionPage',
  setup(__props) {

let dyn_height = ref("");
let windowHeight = ref("");
const mfaModal = ref<null>(null);
onMounted(() => {
  nextTick(function () {
    window.addEventListener("resize", onResize);
    onResize();
  });
  document.getElementById("mfaModal")?.classList.add("show");

  const body = $("body");
  if (!body.hasClass("page-opacity")) {
    body.addClass("page-opacity page-bg");
  }
});

const onResize = () => {
  dyn_height.value = (window.innerHeight + "px") as string;
  windowHeight.value = "" + window.innerHeight + "px !important ";
};

const handleByAuthen = () => {
  store.dispatch("User/setPreSession");
  router.push(UserRoute.twoStepAuthenticationSetup);
};

const handleByPasskey = () => {
  webAuthnLogin();
};

const webAuthnLogin = () => {
  userService.mfaWebauthnRegister().then(async (res: any) => {
    try {
      const challengeResponse = res.data.data;
      const attResp = await startRegistration(challengeResponse);
      userService.mfaWebauthnVerifyRegister(attResp).then(async (res: any) => {
        await Utils.afterLoginActions(res.data.data);
        router.push(homeRoute.welcomePage);
      });
    } catch (err: any) {
      showError(err.message);
    }
  });
};

const handleCloseModal = () => {
  router.push(UserRoute.login);
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "col-md-12",
          style: _normalizeStyle({ 'min-height': _unref(dyn_height) })
        }, [
          _createVNode(HeaderLogo, {
            "page-type": '3',
            light_logo: true
          }),
          _createElementVNode("div", {
            class: "row no-padding main-body h-100",
            style: _normalizeStyle({ height: _unref(windowHeight) })
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BrandPattern, { page: "MFASelection" })
            ])
          ], 4)
        ], 4),
        _createElementVNode("div", {
          id: "mfaModal",
          ref_key: "mfaModal",
          ref: mfaModal,
          class: "modal fade mfa-modal show tw-block",
          role: "dialog",
          "aria-labelledby": "mfaModalLabel",
          "data-backdrop": "false"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(mfaSelectionContent, {
                "multiple-options": true,
                "from-login": true,
                "onUpdate:click:authen": handleByAuthen,
                "onUpdate:click:passkey": handleByPasskey,
                onClose: handleCloseModal
              })
            ])
          ])
        ], 512)
      ])
    ])
  ]))
}
}

})